import React from 'react'
import MessageUI from '../../../widgets/output/MessageUI'
import ModalFormUI from '../../../widgets/form/ModalFormUI'

const AlertRuleDeleteModalUI = ({context, messageList, successMsg, errorList, setErrorList,
    // modes
    alertRuleId, submitted,
    // event handlers
    onSubmit, onCancel,
  }) =>
  <ModalFormUI
    context={context}
    messageList={messageList}
    titleMessageKey='c_delete_alert_rule'
    buttonMessageKey='c_delete'
    cancelMessageKey='c_cancel'

    isOpen={alertRuleId !== null}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onRequestClose={onCancel}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <MessageUI messageList={messageList} messageKey='c_delete_alertrule_cnf' />
  </ModalFormUI>

export default AlertRuleDeleteModalUI
